
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    defaultAggregatorPage () {
      return this.$store.state.config.aggregator_pages.news_page;
    },
    aggregatorPages () {
      return this.$store.state.config.aggregator_pages.additional_pages;
    },
    postAggregatorPage () {
      if (this.aggregatorPages) {
        const aggPage = this.aggregatorPages.find(page => page.post_type === this.post.type);
        return aggPage ? aggPage.page : this.defaultAggregatorPage;
      }
      return this.defaultAggregatorPage;
    },
  },
};
